import type { ReactElement } from "react";

interface PageTitleProps {
  readonly children: string;
}

export function PageTitle({ children }: PageTitleProps): ReactElement {
  return <title>{`787 Study | ${children}`}</title>;
}
